import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../modals/modal.component";
import { ErrorsType } from "../../../errors/errors.type";
import { ErrorsComponent } from "../../../errors/errors.component";
import { UserType } from "../../../../types/user.type";
import apiClient from '../../../../helpers/apiClient';

export interface EditProfileNameProperties {
  success: boolean;
  setSuccess: (success: boolean) => void;
  setScreen: (screen: string) => void;
  userInfo: UserType;
  setLoading: (loading: boolean) => void;
  setUser: (user: UserType) => void;
  setScene: (scene: string | undefined) => void;
}

export function EditProfileNameComponent(properties: EditProfileNameProperties): JSX.Element {
  const { t } = useTranslation();

  const [errors, setErrors] = useState<ErrorsType>({})

  const [name, setName] = useState<string>(properties.userInfo.name);

  const [surnames, setSurnames] = useState<string>(properties.userInfo.surnames);

  const onSubmit = () => {
    if (properties.userInfo.is_generic) return;

    const errors: { name?: string[], surnames?: string[] } = {};

    if (!name || name.trim() === '') {
      errors.name = [t('edit.profile.form.required')];
    }

    if (!surnames|| surnames.trim() === '') {
      errors.surnames = [t('edit.profile.form.required')];
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    properties.setLoading(true);

    setErrors({});

    apiClient.put(`/api/user/edit-profile/${properties.userInfo.id}`, {
      name: name,
      surnames: surnames
    }).then((response) => {
      const responseWithToken = {
        ...response.data.items[0],
        access_token: properties.userInfo.access_token
      }

      properties.setUser(responseWithToken);

      setTimeout(() => {
        properties.setSuccess(true);
        properties.setLoading(false);
      }, 1000);
    }).catch((error) => {
      setTimeout(() => {
        properties.setLoading(false);

        const errors = error?.response?.data?.errors;

        if (errors) {
          setErrors(errors)
        } else {
          setErrors({ general: ['Error de conexión'] })
        }
      }, 1000);
    });
  }

  return <>
    <ErrorsComponent errors={errors} name="general" />
    <div
      className='Form'
      style={{
          paddingTop: 10,
      }}
    >
      {
        properties.success && <Modal
          isOpen={true}
          type='success'
          onClose={() => {
            properties.setSuccess(false);
            properties.setScene(undefined);
          }}
          body={{
            title: t('edit.profile.name'),
            content: t('edit.profile.success')
          }}
        >

        </Modal>
        }
      <p>{t('edit.profile.edit.name')}</p>
      <div className="Input">
        <i className="las la-user"></i>
        <input
            type="text"
            placeholder=""
            disabled={!!properties.userInfo.is_generic}
            onChange={(event) => {
              setName(event.target.value)
            }}
            value={name}
        />
      </div>
      <ErrorsComponent errors={errors}  name="name" />
      <p>{t('edit.profile.edit.surnames')}</p>
      <div className="Input">
        <i className="las la-user"></i>
        <input
          type="text"
          placeholder=""
          disabled={!!properties.userInfo.is_generic}
          onChange={(event) => {
            setSurnames(event.target.value)
          }}
          value={surnames}
        />
      </div>
      <ErrorsComponent errors={errors} name="surnames" />
      {properties.userInfo.is_generic && (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 12, padding: '10px 12px', backgroundColor: '#f0f4ff', borderRadius: 6, color: '#4a5568', fontSize: 13 }}>
          <i className="las la-info-circle" style={{ fontSize: 18, marginTop: 1, color: '#3182ce', flexShrink: 0 }}></i>
          <span>{t('edit.profile.generic_user_info')}</span>
        </div>
      )}
      <div className="Space" />
      <div className={`Submit${properties.userInfo.is_generic ? ' disabled' : ''}`} onClick={onSubmit} style={properties.userInfo.is_generic ? { opacity: 0.5, pointerEvents: 'none' } : {}} >
              {t('form.update.title')}
      </div>
    </div>
  </>
}
